import React, { Component } from 'react';
import CreateForm from './create-form';

class OrganizationCreateApp extends Component {

    render() {

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <h3 className="text-center">Create an Organization</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <CreateForm />
                    </div>
                </div>
            </div>
        );
    }
}

export {
    OrganizationCreateApp
};
